<template>
  <v-expansion-panels :disabled="getListErrored.length == 0">
    <v-expansion-panel>
      <v-expansion-panel-header>
        {{ $t("status.log") }}
      </v-expansion-panel-header>
      <v-expansion-panel-content class="pa-0">
        <v-data-table
          :items="getListErrored"
          :headers="headers"
          hide-default-footer
          :search="search"
          class="text-center elevate-0"
          @click:row="itemSelected"
        >
          <template v-slot:[`item.problems`]="{ item }">
            <template v-if="item.problems.length > 1">
              <v-icon class="mr-2">
                {{ "mdi-" + item.problems[0].icon }}
              </v-icon>
              <v-icon>{{ "mdi-" + item.problems[1].icon }}</v-icon>
            </template>
            <template v-else>
              <v-icon>{{ "mdi-" + item.problems[0].icon }}</v-icon>
            </template>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: {
    listErrored: {
      type: Array,
      required: true,
    },
    search: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      headers: [
        { text: this.$t("status.players"), value: "name", align: "start" },
        {
          text: this.$t("status.last-connection"),
          value: "lastConnection",
          align: "start",
        },
        {
          text: this.$t("status.problems"),
          value: "problems",
          align: "middle",
        },
      ],
    };
  },
  computed: {
    getListErrored() {
      return this.listErrored;
    },
  },
  created() {
    //
  },
  methods: {
    itemSelected(item) {
      this.$emit("itemSelected", [item]);
    },
  },
};
</script>

<style></style>
